import ContentURLModal from './ContentURLModal';

export default ContentURLModal;
